import {restHelperService} from "./rest-helper.service";


export const imageService = {
    getImage,
    addImage,
    overwriteImage,
    base64Encode
};

function getImage(id) {
    let request = {};
    if (id) {
        request = {"id": id};
    }
    return restHelperService.createGetRequest("/rest/data/image", request)
        .then(res => {
            let response = restHelperService.getResponse(res);
            return Promise.resolve(response);
        }).catch((res) => {
            return restHelperService.handleCatch(res)
        })
}

function addImage(file, base64Data) {
    const request = {
        items: [{name: file.name, type: file.type, data: base64Data}]
    };
    return restHelperService.createPostRequest("/rest/data/image", request)
        .then(res => {
            let response = restHelperService.getResponse(res);
            return Promise.resolve(response);
        }).catch((res) => {
            return restHelperService.handleCatch(res)
        })
}

function overwriteImage(id, file, base64Data) {
    const request = {id: id,name: file.name, type: file.type, data: base64Data};
    return restHelperService.createPutRequest("/rest/data/image", request)
        .then(res => {
            let response = restHelperService.getResponse(res);
            return Promise.resolve(response);
        }).catch((res) => {
            return restHelperService.handleCatch(res)
        })
}


function base64Encode(data) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(data);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}
